import React from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import $ from 'jquery';

class AssignRatingPageEmployee extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRatingPageEmployeeId: null, // To store the selected employee's ID
            ratingPageEmployeeOptions: [], // To store the list of employees
        };

        this.selectRef = React.createRef(); // Reference to the Select2 input
        this.loadRatingPageEmployeeOptions = this.loadRatingPageEmployeeOptions.bind(this);
    }

    loadRatingPageEmployeeOptions() {
        const businessId = this.props.feedback?.business?.business_id;
        axios.get(`/business/${businessId}/rating-page-employee/list`)
            .then((response) => {
                const ratingPageEmployeeOptions = response.data.ratingPageEmployees.map(employee => ({
                    id: employee.id,
                    text: `${employee.name}`
                }));

                this.setState({
                    ratingPageEmployeeOptions,
                });

                // Initialize Select2 after data is loaded
                $(this.selectRef.current).select2({
                    data: ratingPageEmployeeOptions,
                    theme: 'bootstrap-5',
                    placeholder: __('Select an employee'),
                    allowClear: false,
                });

                // Preselect the current employee (if available) after initialization
                if (this.state.selectedRatingPageEmployeeId) {
                    $(this.selectRef.current).val(this.state.selectedRatingPageEmployeeId).trigger('change');
                }

                // Handle change event for Select2
                $(this.selectRef.current).on('change', (e) => {
                    this.setState({selectedRatingPageEmployeeId: e.target.value});
                });
            })
            .catch((error) => {
                console.error(__('Error loading employee options') + ':', error);
            });
    }

    componentDidMount() {
        // Set the preselected employee ID (pass it via props when opening the modal)
        const preselectedEmployeeId = this.props.selectedRatingPageEmployeeId; // Get from props
        this.setState({selectedRatingPageEmployeeId: preselectedEmployeeId}, () => {
            // Load the employee options and initialize Select2
            this.loadRatingPageEmployeeOptions();
        });
    }

    componentWillUnmount() {
        // Clean up Select2 to prevent memory leaks
        $(this.selectRef.current).select2('destroy');
    }

    render() {
        return (
            <div className="simple-sms-field forward-feedback-wrapper">
                <div className="row">
                    <div className="col-sm-12 mb-3">
                        {/* The select input for Select2 */}
                        <select ref={this.selectRef} className="form-control" id="rating-employee-select"/>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        feedback: state.feedback_detail, // From Redux store
        selectedRatingPageEmployeeId: state.modal.selectedRatingPageEmployeeId // Assuming this is passed from parent component/modal trigger
    };
}

export default connect(mapStateToProps)(AssignRatingPageEmployee);
